// extracted by mini-css-extract-plugin
export default {"Suggestion":"_Suggestion--vWONa","AcceptSuggestionAnimation":"_AcceptSuggestionAnimation--Ut9KI","suggestionAccept":"_suggestionAccept--Etwkm"};